/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-11-18 08:46:07
 * @LastEditors: jyf
 * @LastEditTime: 2022-12-07 17:32:45
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace CustomerBase {
    /**
    *  获取客户/基地列表
    */
    export var GetList = (body: GetCustomerBaseListPayload): Promise<any> => {
        return Get(`/msls/CustomerBase/GetList?${qs.stringify(body)}`, {});
    };
    /**
    * 获取客户/基地详情
    */
    export var GetDetail = (id: string): Promise<CustomerBaseDetailVM> => {
        return Get(`/msls/CustomerBase/GetDetail/${id}`, {});
    };
    /**
     * 新增客户/基地
     */
    export var Add = (body: AddOrEdiCustomerBaseVM): Promise<any> => {
        return Post(`/msls/CustomerBase/Add`, body);
    };
    /**
     * 编辑客户/基地
     */
    export var Edit = (id: string, body: AddOrEdiCustomerBaseVM): Promise<any> => {
        return Post(`/msls/CustomerBase/Edit/${id}`, body);
    };
    /**
     * 删除客户/基地
     */
    export var Delete = (id: string): Promise<any> => {
        return Put(`/msls/CustomerBase/Delete/${id}`, {});
    };
    /**
     * 获取客户/基地列表下拉
     */
    export var GetDropDownList = (data): Promise<any> => {
        return Get(`/msls/CustomerBase/GetDropDownList`, data);
    };
    /**
    * 获取获取客户/基地维护的下属车队
    */
    export var GetSettleUserDetail = (customerBaseId: string): Promise<any> => {
        return Get(`/msls/CustomerBase/GetCarrierByCustomerBase/${customerBaseId}`, {});
    };
    /**
     * 获取客户/基地列表
     */
    export interface GetCustomerBaseListPayload {
        customerBaseName?: string;
        customerBaseContactName?: string;
        isEnabled?: boolean;
        startTime?: string;
        endTime?: string;
        asc?: boolean;
        orderBy?: string|any;
        skip?: number;
        count?: number
    }
    export interface CustomerBaseItemVM {
        /**
         * 主键id
         */
        id?: string;
        /**
         * 客户/基地名称
         */
        customerBaseName?: string | null;
        /**
         * 客户/基地编码
         */
        customerBaseCode?: string | null;
        customerBaseType?: string;
        /**
         * 客户/基地分类str
         */
        customerBaseTypeStr?: string | null;
        /**
         * 联系人姓名
         */
        customerBaseContactName?: string | null;
        /**
         * 联系人手机号
         */
        customerBaseContactPhone?: string | null;
        /**
         * 地址
         */
        address?: string | null;
        /**
         * 下属车队
         */
        carrierNames?: string | null;
        /**
         * 雨布费用
         */
        rainClothAmount?: number;
        /**
         * 状态
         */
        isEnabled?: boolean;
        /**
         * 创建人
         */
        creator?: string | null;
        /**
         * 创建时间
         */
        creationTime?: string | null;
    };


    export interface CustomerBaseDetailVM {
        /**
      * 客户/基地详情
      */
        id?: string;
        /**
         * 制造企业id
         */
        enterpriseCompanyId?: string | null;
        /**
         * 客户/基地名称
         */
        customerBaseName?: string | null;
        customerBaseType?: string | null;
        /**
         * 客户/基地分类str
         */
        customerBaseTypeStr?: string | null;
        /**
         * 客户/基地编码
         */
        customerBaseCode?: string | null;
        /**
         * 联系人姓名
         */
        customerBaseContactName?: string | null;
        /**
         * 联系人手机号
         */
        customerBaseContactPhone?: string | null;
        /**
         * 省
         */
        province?: string | null;
        /**
         * 市
         */
        city?: string | null;
        /**
         * 区
         */
        county?: string | null;
        /**
         * 详细地址
         */
        detail?: string | null;
        /**
         * 省Str
         */
        provinceStr?: string | null;
        /**
         * 市Str
         */
        cityStr?: string | null;
        /**
         * 区Str
         */
        districtStr?: string | null;
        /**
         * 下属车队（客户/基地与车队关系表）
         */
        carrierRelations?: Array<CarrierRelationVM>;
        /**
         * 雨布费用
         */
        rainClothAmount?: number;
        /**
         * 状态
         */
        isEnabled?: boolean;
        /**
         * 备注
         */
        remark?: string | null;
    }

    export interface CarrierRelationVM {
        /**
       * 关系主键id
       */
        relationId?: string | null;
        /**
         * 车队id
         */
        carrierId?: string | null;
        /**
         * 车队名称
         */
        carrierName?: string | null;
    }


    export interface AddOrEdiCustomerBaseVM {
        id?:string;
        /**
     * 客户/基地名称
     */
        customerBaseName?: string | null;
        customerBaseType?: string | null;
        /**
         * 客户/基地编码
         */
        customerBaseCode?: string | null;
        /**
         * 联系人姓名
         */
        customerBaseContactName?: string | null;
        /**
         * 联系人手机号
         */
        customerBaseContactPhone?: string | null;
        /**
         * 省
         */
        province?: string | null;
        /**
         * 市
         */
        city?: string | null;
        /**
         * 区
         */
        county?: string | null;
        /**
         * 详细地址
         */
        detail?: string | null;
        /**
         * 下属车队
         */
        carrierRelations?: Array<CarrierRelationVM>;

        
        carrierRelationsList:any;
        /**
         * 雨布费用(默认50元/车,可修改)
         */
        rainClothAmount?: number | string;
        /**
         * 状态
         */
        isEnabled?: boolean | null;
        /**
         * 备注
         */
        remark?: string | null;
    }
}